import { Box } from "@mui/material";
import {
  Datagrid,
  EditButton,
  List,
  NumberField,
  ShowButton,
  TextField,
  FunctionField,
} from "react-admin";
import { UserType } from "../../enums/common";
import { ZohoBaseUrl, ZohoModulesUrl } from "../../enums/zoho";
import { useAppSelector } from "../../store/hooks";
import CallButton from "../Common/CallButton/CallButton";
import LinkField from "../Common/LinkField";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
  { type: "text", label: "Search by Name", source: "fname" },
  { type: "text", label: "Search by Number", source: "mobile" },
  { type: "text", label: "Search by Id", source: "id" },
];

const Customers = (props: any) => {
  const isCustomSelectOpen = useAppSelector(
    (state) => state.customSelect.value.open
  );
  return (
    <List
      {...props}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Customers">
      <Datagrid bulkActionButtons={false} size="small" stickyHeader sx={commonDatagridSx}>
        {isCustomSelectOpen && <ResourceSelectDialogButton />}
        <NumberField source="id" sortable={false} />
        <TextField source="fname" sortable={false} />
        <TextField source="lname" sortable={false} />
        <TextField source="email" sortable={false} />
        <FunctionField
          label="address"
          render={(record: any) => (
            <Box minWidth="200px">{record?.address}</Box>
          )}
        />
        <FunctionField
          label="Mobile"
          render={(record: any) => (
            <CallButton
              toPhoneNumber={record?.mobile}
              userType={UserType.CUSTOMER}
              referenceId={record?.id}
              referenceModelName={"CUSTOMER_MODEL"}
            />
          )}
        />
        <TextField source="accountStatus" sortable={false} />
        <TextField source="houseId" sortable={false} />
        <LinkField
          source="contactId"
          href={`${ZohoBaseUrl}${ZohoModulesUrl.CUSTOMER}`}
          sourceRoute
          targetBlank
        />
        <TextField source="accountId" sortable={false} />
        {!isCustomSelectOpen && (
          <FunctionField
            label="Action"
            render={() => {
              return (
                <Box sx={{ display: "flex" }}>
                  <ShowButton />
                  <EditButton />
                </Box>
              );
            }}
          />
        )}
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};
export default Customers;
